import React, { useState } from "react";
import { CONFIG } from "../../utils/config";
import "./Contact.css";
import {useLocation} from "react-router-dom";

interface ContactFormData {
  customerName: string;
  contactInfo: string;
  inquiryType: string;
  inquiryMessage: string;
}
interface FormData {
  customerName?: string;
  contactInfo?:string;
  inquiryType?:string;
  inquiryMessage?:string;
  // name: string;
  // email: string;
}
interface ContactFormProps {
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void; // 폼 제출 이벤트
  onChange?: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  formData?: FormData; // 위에서 정의한 폼 데이터 타입
  isSubmitting?: boolean; // 제출 중 상태 (true/false)
}

const ContactForm = ({onSubmit,onChange,formData,isSubmitting}:ContactFormProps) => {
  return (
    <>
      <div className="cta-overlay"></div>
      <div className="container">
        <div className="cta-container-grid">
          <div className="cta-content-left">
            <div className="section-meta section-meta--white">
              {/*비즈니스 문의*/}
              1:1 문의
            </div>
            <h2 className="cta-title">
              {/*기업의 가치를 높이는*/}
              {/*<br/>*/}
              {/*특별한 파트너십*/}
              추가로 궁금한 내용이 있다면<br/>
              문의를 남겨주세요
            </h2>
            <p className="cta-description">
              결제, 계정, 서비스 이용 관련 문의 또는 비즈니스 협업 문의를 남겨주시면 빠르게 답변드리겠습니다.
              {/*기억의 서랍은 기업 임직원과 고객을 위한 특별한 스토리북 프로그램을*/}
              {/*제공합니다.*/}
              {/*<br/>*/}
              {/*맞춤형 제작으로 기업의 가치를 높이고 소중한 관계를 만들어보세요.*/}
            </p>
          </div>
          
          <div className="cta-form-right">
            <form onSubmit={onSubmit} className="contact-form">
              {/*<h3 className="form-title">비즈니스 문의</h3>*/}
              <h3 className="form-title">1:1 문의</h3>
              
              <div className="form-group">
                <input
                  type="text"
                  name="customerName"
                  placeholder="이름 (필수)"
                  value={formData?.customerName}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <input
                  type="text"
                  name="contactInfo"
                  placeholder="전화번호 또는 이메일 (필수)"
                  value={formData?.contactInfo}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="form-group">
                <select
                  name="inquiryType"
                  value={formData?.inquiryType}
                  onChange={onChange}
                  required
                  style={{color: formData?.inquiryType ? "#333" : "#999"}}
                >
                  <option value="">문의 유형을 선택하세요</option>
                  <option value="대량/단체 구매">대량/단체 구매</option>
                  <option value="비즈니스 제안">비즈니스 제안</option>
                  <option value="구매/사용/결제">구매/사용/결제</option>
                  <option value="기타">기타</option>
                </select>
              </div>
              
              <div className="form-group">
                <textarea
                  name="inquiryMessage"
                  placeholder="문의 내용을 입력해주세요. (필수)"
                  rows={5}
                  value={formData?.inquiryMessage}
                  onChange={onChange}
                  required
                ></textarea>
              </div>
              
              <button
                type="submit"
                className="form-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? "전송 중..." : "문의하기"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

const Contact: React.FC = () => {
  const [formData, setFormData] = useState<ContactFormData>({
    customerName: "",
    contactInfo: "",
    inquiryType: "",
    inquiryMessage: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const loaction = useLocation();
  
  
  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // 문의 유형 필드 색상 처리
    if (name === "inquiryType") {
      const selectElement = e.target as HTMLSelectElement;
      selectElement.style.color = value ? "#333" : "#999";
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // 폼 데이터 준비
      const formDataToSend = new FormData();
      formDataToSend.append("customer-name", formData.customerName);
      formDataToSend.append("contact-info", formData.contactInfo);
      formDataToSend.append("inquiry-type", formData.inquiryType);
      formDataToSend.append("inquiry-message", formData.inquiryMessage);

      // Google Apps Script에 전송
      const response = await fetch(CONFIG.FORM_SCRIPT_URL, {
        method: "POST",
        body: formDataToSend,
      });

      const result = await response.json();

      if (result.result === "success") {
        alert(CONFIG.MESSAGES.FORM_SUCCESS);
        setFormData({
          customerName: "",
          contactInfo: "",
          inquiryType: "",
          inquiryMessage: "",
        });
        // 문의 유형 필드 색상 초기화
        const selectElement = document.querySelector(
          'select[name="inquiryType"]'
        ) as HTMLSelectElement;
        if (selectElement) {
          selectElement.style.color = "#999";
        }
      } else {
        throw new Error(result.error || CONFIG.MESSAGES.FORM_ERROR);
      }
    } catch (error) {
      console.error("Form submission error:", error);
      alert(CONFIG.MESSAGES.FORM_ERROR + "\n" + (error as Error).message);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  
  console.log(formData,'/[formData]')

  
  if(loaction?.pathname === `/`) {
    return (
      <>
        <section id="contact" className={`cta-section`}>
          <ContactForm
            onSubmit={handleSubmit}
            onChange={handleInputChange}
            formData={formData}
            isSubmitting={isSubmitting}
          />
        </section>
      </>
    )
  }
  
  if (loaction?.pathname !== `/`) {
    return (
      <>
        <div className={`content_wrap contact`}>
          <section id="contact" className={`cta-section`}>
            <ContactForm
              onSubmit={handleSubmit}
              onChange={handleInputChange}
              formData={formData}
              isSubmitting={isSubmitting}
            />
          </section>
        </div>
      </>
    )
  }
  
  return null
  
};
  
  export default Contact;
